import React from 'react'
import css from './style.scss'
import api from '../api'
import Invoice from './invoice';
class Invoices extends React.Component{
  constructor(props){
    super(props)
    this.state={
      invoices:[]
    }
  }
  componentDidMount(){
    console.log("invoices")
    api.getInvoices().then(invoices=>{
      console.log("invoices:", invoices)
      this.setState({invoices})
    })
  }
  render(){
    return(
      <div>
        <h4>Your Invoices</h4>
        <div className={css.invoices}>
          {this.state.invoices.map(i=><Invoice key={i.date} {...i}/>)}
        </div>
      </div>
    )
  }
}

export default Invoices;


// WEBPACK FOOTER //
// ./src/components/settings/invoices/index.js